import { api } from '../apiSlice';

// The footer's "Join our mailing list" box (task #330). The address goes
// nested under mailing_list_signup: that is the one shape the server reads,
// and the one its log filter masks.
export const mailingListApi = api.injectEndpoints({
  endpoints: build => ({
    addMailingListSignup: build.mutation({
      query: (email) => ({
        url: '/mailing_list_signups',
        method: 'POST',
        body: { mailing_list_signup: { email } },
      }),
    }),
  }),
});

export const { useAddMailingListSignupMutation } = mailingListApi;
